import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';

interface InfoCardProps {
  title: string;
  description: string;
  items: string[];
}

export function InfoCard({ title, description, items }: InfoCardProps) {
  return (
    <Card className="border-[#ccd77b] shadow-md bg-white hover:shadow-lg transition-shadow duration-300 rounded-t-xl">
      <CardHeader className="bg-[#f7f8eb] border-b border-[#ccd77b] rounded-t-xl">
        <CardTitle className="text-[#006b69]">{title}</CardTitle>
        <CardDescription className="text-[#36454F] subtitle">{description}</CardDescription>
      </CardHeader>
      <CardContent className="pt-4">
        <ul className="space-y-3">
          {items.map((item, index) => (
            <li key={index} className="flex items-start">
              <Check className="h-5 w-5 text-[#006b69] mr-2 flex-shrink-0" />
              <span className="text-sm">{item}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
